<template>
  <div class="navinfo">
    <ul class="navbox">
      <router-link custom v-for="nav in navs" :key="nav.id" :to="getToLink(nav)"
        :class="nav.id==0||nav.id==7?'item':'itemflex'" tag="li" v-text="nav.name">
      </router-link>
    </ul>
  </div>
</template>

<script>
import { NAV_MODELS } from '@/config.js'
export default {
  name: "Nav",
  components: {
  },
  data() {
    return {
      navs: NAV_MODELS
    }
  },
  created() {
    this.dealPlatesForNav();
  },
  mounted() {
  },
  methods: {
    /**
     * navs 同步plates中数据uuid作为请求的url
     */
    dealPlatesForNav() {
      let { plates } = this.$store.state;
      this.navs = this.navs.map((item) => {
        let plate = plates.find(plate => plate.name.replace("T","") == item.name);
        plate&&(item['uuid'] = plate.uuid);
        return item;
      });
      console.log("navs",this.navs);
    },
    getToLink(nav) {
      if (nav.type == "view") {
        return nav.path + (nav.uuid || '未配置nav');
      }
      if (nav.type == "info") {
        return nav.path + (nav.uuid || '未配置nav') +"/000000";
      }
      return nav.path
    }
  }
};
</script>
<style scoped>
.navinfo{
  width: 100%;
  height: 56px;
  background: #2479D3;
}
.router-link-exact-active {
  background: #226DBB;
}
.navinfo>.navbox{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 56px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.navinfo>.navbox>.item{
  width: 108px;
  height: 100%;
}
.navinfo>.navbox>.itemflex {
  flex: 1;
  height: 100%;
}
</style>
